import { createContext } from "react";

const ClusterContext = createContext({
  registerMarkers: () => {},
  unRegisterMarkers: () => {},
});

export default ClusterContext;
